import { imageNames } from "@/src/constants/imageConstants.js";

export const meetingAgentHeaders = [
  { label: "Agent Name", key: "agent_details", width: 3 },
  {
    label: "Type",
    key: "type",
    width: 2,
    render: (value) => AGENT_TYPES[value] || value,
  },
  {
    label: "Participants",
    key: "participants_info",
    width: 2,
  },
  { label: "Duration", key: "duration", width: 2 },
  { label: "Booking", key: "bookings", width: 2 },
  { label: "", key: "actions", width: 2 },
];

export const durationOptions = [
  { value: 15, label: "15min" },
  { value: 30, label: "30min" },
  { value: 45, label: "45min" },
  { value: 60, label: "60min" },
  { value: 90, label: "90min" },
  { value: 120, label: "120min" },
  { value: 150, label: "150min" },
  { value: 180, label: "180min" },
];

export const daysOfWeeks = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const defaultTimeSlots = {
  Sunday: { unavailable: true },
  Monday: { slots: [{ start: "09:00am", end: "5:00pm" }] },
  Tuesday: { slots: [{ start: "09:00am", end: "5:00pm" }] },
  Wednesday: { slots: [{ start: "09:00am", end: "5:00pm" }] },
  Thursday: { slots: [{ start: "09:00am", end: "5:00pm" }] },
  Friday: { slots: [{ start: "09:00am", end: "5:00pm" }] },
  Saturday: { unavailable: true },
};

export const webConferenceVendors = {
  GOOGLE_MEET: "google_meet",
  SUPER_MEET: "super_meet",
  AI_SUPERMEET: "ai_supermeet",
  MS_TEAMS: "ms_teams",
  ZOOM: "zoom",
};

export const locationOptionsMap = {
  google_meet: {
    label: "Google Meet",
    icon: imageNames.GOOGLE_MEET,
  },
  super_meet: {
    label: "Super Meet",
    icon: imageNames.SUPER_MEET,
  },
  ms_teams: {
    label: "MS Teams",
    icon: imageNames.MS_TEAMS,
  },
  zoom: {
    label: "Zoom",
    icon: imageNames.ZOOM_ICON,
  },
  ai_supermeet: {
    label: "AI SuperMeet",
    icon: imageNames.SUPER_MEET,
  },
};

export const agentTypeOptions = [
  {
    id: "One-on-One",
    title: "One-on-One",
    description: "Create a personal meeting agent for individual scheduling",
    icon: imageNames.USER,
  },
  {
    id: "Round Robin",
    title: "Round Robin",
    description:
      "Create a team-based meeting agent that rotates between team members",
    icon: imageNames.ROUND_ROBIN_GREY,
  },
];

export const timeUnitOptions = [
  { value: "business", label: "Business days" },
  { value: "calendar", label: "Calendar days" },
];

export const timeOptionsConst = [
  { value: "hours", label: "Hours" },
  { value: "days", label: "Days" },
];

export const bufferTimeOptions = [
  { value: 5, label: "5min" },
  { value: 10, label: "10min" },
  { value: 15, label: "15min" },
  { value: 20, label: "20min" },
  { value: 25, label: "25min" },
  { value: 30, label: "30min" },
];

export const AGENT_TYPES = {
  one_on_one: "One-on-One",
  round_robin: "Round Robin",
};
